import { Link } from 'react-router-dom';
import MentorPortalService, { MentorMenteeCard } from './MentorPortalService';
import { initialsFromName, joinPresent } from './mentorDashboardFormat';

type Props = {
    mentees: MentorMenteeCard[];
};

const MentorMenteesWidget = ({ mentees }: Props) => (
    <div className="col-lg-6" aria-label="My mentees">
        
        
        <div className="card border-0 shadow-sm rounded-3 bg-white h-100">
                  <div className="card-header bg-white border-bottom border-light-subtle p-3 d-flex align-items-center justify-content-between">
                    <h6 className="fw-bold mb-0 text-dark">My Mentees</h6>
                    <Link className="btn btn-link text-primary p-0 font-12 fw-bold text-decoration-none" to="/alumni/mentorship/mentees">View all →</Link>
                  </div>
                  <div className="card-body p-3 d-flex flex-column gap-3">

                    

                    {mentees.length === 0 ? (
            <p className="mdash-empty">No published mentees yet.</p>
        ) : (
            mentees.map((mentee) => {
                const trackNames = (mentee.tracks || [])
                    .map((track) => track.trackName)
                    .filter((name): name is string => !!name);
                // Campus name is not on GET /mentor/mentees (campusId only) — omit, do not invent.
                const meta = joinPresent([mentee.program, trackNames.join(', ') || null]);
                const uuid = mentee.menteeUuid;
                return (
                    <div key={mentee.pairId ?? mentee.menteeUuid ?? mentee.menteeName} className="bg-light bg-opacity-50 border border-light-subtle rounded-3 p-3 d-flex gap-3 align-items-start">
                        <svg width="40" height="40" className="rounded-circle border border-primary border-opacity-25 flex-shrink-0">
                            <rect width="100%" height="100%" fill="#E0F4F2"></rect>
                            <text x="50%" y="55%" dominant-baseline="middle" text-anchor="middle" fill="#0C9688" font-size="14" font-weight="bold" font-family="Outfit">{initialsFromName(mentee.menteeName)}</text>
                        </svg>
                        
                        <div className="flex-grow-1">
                            {mentee.menteeName ? <div className="fw-bold font-14">{mentee.menteeName}</div> : null}
                            {meta ? <div className="text-secondary small font-12">{meta}</div> : null}
                            {trackNames.length > 0 ? (
                                <div className="d-flex gap-1 mt-2">
                                    {trackNames.map((name) => (
                                        <span key={name} className="badge bg-light text-secondary font-11 border border-light-subtle">
                                            {name}
                                        </span>
                                    ))}
                                </div>
                            ) : null}
                        </div>

                        <div className="d-flex flex-column gap-2">
                                {uuid ? (
                                    <Link
                                        to={MentorPortalService.messagesHref(uuid)}
                                        className="btn btn-sm btn-outline-secondary font-11 py-1"
                                    >
                                        💬 Message
                                    </Link>
                                ) : null}
                                <button type="button" className="btn btn-sm btn-outline-secondary font-11 py-1" disabled title="Scheduling arrives with Sessions">
                                    📅 Schedule
                                </button>
                        </div>

                        
                    </div>
                );
            })
        )}

                  </div>

                </div>
    </div>
);

export default MentorMenteesWidget;
